import {
    translateParts,
    translatePartsOptional,
} from 'aos-helpers/src/helpers/translations/Translations'
import { Dropdown } from 'aos-ui-universal'
import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { TaskFormField } from '../../TaskFormField'

interface TaskSelectFieldProps<T> {
    keyPrefix: string
    items: T[]
    value: T | undefined
    labelRenderer(item: T): string
    valueRenderer?(item: T): ReactNode
    required?: boolean
    isError?: boolean
    seleniumLocation?: string
    className?: string
    onChange(value: T | undefined): void
}

/** Universal replacement for the legacy `LabeledSelect`. */
export function TaskSelectField<T>({
    keyPrefix,
    items,
    value,
    labelRenderer,
    valueRenderer,
    required,
    isError,
    seleniumLocation,
    className,
    onChange,
}: TaskSelectFieldProps<T>) {
    const { t } = useTranslation()

    return (
        <TaskFormField
            className={className}
            label={translateParts(t)(keyPrefix, 'label')}
            required={required}
            error={isError ? translatePartsOptional(t)(keyPrefix, 'error') : undefined}
            seleniumLocation={seleniumLocation}
        >
            <Dropdown<T>
                items={items}
                value={value ?? null}
                labelRenderer={labelRenderer}
                valueRenderer={valueRenderer}
                placeholder={translatePartsOptional(t)(keyPrefix, 'placeholder')}
                isInvalid={isError}
                onChange={next => onChange(next ?? undefined)}
            />
        </TaskFormField>
    )
}
